"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _fileUploader = require("baseui/file-uploader");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var Uploader = function (_React$Component) {
  _inherits(Uploader, _React$Component);

  var _super = _createSuper(Uploader);

  function Uploader(props) {
    var _this;

    _classCallCheck(this, Uploader);

    _this = _super.call(this, props);
    _this.state = {
      progressAmount: 0
    };
    _this.reset = _this.reset.bind(_assertThisInitialized(_this));
    _this.handleDrop = _this.handleDrop.bind(_assertThisInitialized(_this));
    _this.startProgress = _this.startProgress.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Uploader, [{
    key: "handleDrop",
    value: function handleDrop(acceptedFiles, rejectedFiles) {
      var _this2 = this;

      var contentCallback = this.props.contentCallback;
      var textType = /text.*/;
      var file = acceptedFiles[0];

      if (!file.type || file.type.match(textType) || file.type.match(/geo/) || file.type.match(/json/)) {
        var reader = new FileReader();

        reader.onload = function (e) {
          _this2.setState({
            progressAmount: 100
          });

          _this2.reset();

          var text = reader.result;
          typeof contentCallback === 'function' && contentCallback({
            text: text,
            name: file.name
          });
        };

        reader.readAsText(file);
      } else {
        this.setState({
          progressAmount: 100
        });
        this.reset();
        console.log("File not supported!");
      }

      this.startProgress();
    }
  }, {
    key: "startProgress",
    value: function startProgress() {
      var _this3 = this;

      this.intervalId = setInterval(function () {
        if (_this3.state.progressAmount >= 100) {
          _this3.reset();
        } else {
          _this3.setState({
            progressAmount: _this3.state.progressAmount + 10
          });
        }
      }, 500);
    }
  }, {
    key: "reset",
    value: function reset() {
      clearInterval(this.intervalId);
      this.setState({
        progressAmount: 0
      });
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement("center", {
        className: "file-upload"
      }, React.createElement(_fileUploader.FileUploader, {
        onCancel: this.reset,
        onDrop: this.handleDrop,
        progressAmount: this.state.progressAmount,
        progressMessage: this.state.progressAmount && "Uploading... ".concat(this.state.progressAmount, "% of 100%")
      }));
    }
  }]);

  return Uploader;
}(React.Component);

exports["default"] = Uploader;